
import React from "react";
import { formatDate, toISODate } from "../utils/timelineUtils";

export default function TimelineHeader({ dates = [] }) {
  const today = toISODate(new Date());

  return (
    <div className="occ-timeline-header">
      <div className="occ-room-heading">
        <strong>ROOM / TYPE</strong>
        <span>Room availability</span>
      </div>

      <div className="occ-days-heading">
        {dates.map((date) => {
          const iso = toISODate(date);
          const isToday = iso === today;

          return (
            <div
              key={iso}
              className={`occ-day-heading ${
                isToday ? "is-today" : ""
              }`}
              aria-current={isToday ? "date" : undefined}
            >
              <span className="occ-day-weekday">
                {formatDate(date, { weekday: "short" })}
              </span>

              <strong className="occ-day-number">
                {formatDate(date, { day: "numeric" })}
              </strong>

              {isToday && (
                <span className="occ-day-today-label">
                  Today
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
